<template>
<div class="mb-15">
  <div style="text-align: end;">
    <v-btn
          variant="outlined"
          color="primary"
          style="width:200px; margin-bottom: 32px;"
          @click="openAddChildDefaultScheduleModal"
          :loading="isUpdatingSchedule || isFetching"
          >登園パターン設定
    </v-btn>
  </div>
  <v-row class="mb-4">
    <v-col>
      <month-pager class="mr-4" v-model="yearMonth" />
    </v-col>
    <v-col>
      <v-btn
        variant="flat"
        color="primary"
        style="width:200px"
        @click="addDefaultSchedules"
        :disabled="isUpdatingSchedule || isFetching"
        :loading="isUpdatingSchedule || isFetching"
      >登園パターン一括登録</v-btn>
    </v-col>
    <!--
    <v-col>
      <v-btn
        variant="flat"
        color="primary"
        style="width:80%"
        @click="openAddChildDefaultScheduleModal"
        :loading="isUpdatingSchedule || isFetching"
        >登園パターン設定</v-btn>
    </v-col>
    -->
    <v-col>
      <v-select
        filled
        label="クラス"
        density="compact"
        :items="classes"
        item-title="className"
        item-value="classId"
        v-model="selectedClassId"
        clearable
        color="primary"
      ></v-select>
    </v-col>
  </v-row>
  <v-progress-linear
    indeterminate
    color="primary"
    class="my-4"
    v-if="isFetching"
  ></v-progress-linear>
  <div>
    <scrollable-panels-2 :leftWidth="280">
      <template #left-panel-header>
        <div class="panel-header panel-left">
          <div class="schedule-col name schedule-header-cell">
            氏名
          </div>
        </div>
      </template>
      
      <template #left-panel-body>
        <div class="panel-left">
          <div 
            class="schedule-row"
            v-for="(schedule, i) in scheduleTableRows"
            :key="`row-${i}`"
          >
            <div class="schedule-col name schedule-body-cell">
              {{ schedule.name }}
            </div>
            <div class="schedule-col actions schedule-body-cell">
              <v-btn
                size="small"
                block
                variant="outlined"
                color="primary"
                @click="openBulkAddScheduleModal(schedule.child)"
              >一括登録</v-btn>
            </div>
          </div>
        </div>
      </template>

      <template #center-panel-header>
        <div class="panel-header panel-center" :style="`width: ${numberOfDates * 50}px; position: sticky; top: 0;`">
          <div 
            class="schedule-col date schedule-header-cell"
            v-for="date in tableDates"
            :key="date"
            :style="`${date.indexOf('(土)') >= 0 ? 'color: blue;' : ''}${date.indexOf('(日)') >= 0 ? 'color: red;' : ''}`"
          >
            {{ date }}
          </div>
        </div>
      </template>
      <template #center-panel-body>
        <div class="panel-center">
          <div 
            class="schedule-row"
            v-for="(schedule, i) in scheduleTableRows"
            :key="`row-${i}`"
            :style="`width: ${numberOfDates * 50}px;`"
          >
            <div 
              :class="[
                'schedule-col date',
              ]"
              v-for="s in schedule.schedules"
              :key="s.date"
            >
              <div
                v-if="s.abbreviation=='出'"
                :class="[
                  'schedule-body-cell date',
                  s.abbreviation ? 'active' : ''
                ]"
                :style="`background-color: ${s.color}; color: white; font-size: 12px; padding: 2px; font-weight: bold;`"
                @click="openEditScheduleModal(schedule.child, s)"
              >
                <!-- {{ s.abbreviation }} -->
                {{ s.startMinFormatted }}<br> {{ s.endMinFormatted }}
              </div>
              <div
                v-if="s.abbreviation=='休'"
                :class="[
                  'schedule-body-cell date',
                  s.abbreviation ? 'active' : ''
                ]"
                :style="`background-color: ${s.color}; color: white;`"
                @click="openEditScheduleModal(schedule.child, s)"
              >
                {{ s.abbreviation }}
              </div>
              <div
                v-if="s.status==null"
                class="schedule-body-cell date add"
                @click="openAddScheduleModal(schedule.child, s.date)"
              >
                <v-icon small color="#d0d0d0">mdi-plus</v-icon>
              </div>
            </div>
          </div>
        </div>
      </template>
    </scrollable-panels-2>
  </div>

  <!--登園パターン設定ダイアログ-->
  <v-dialog
    max-width="1080px"
    v-model="isAddChildDefaultScheduleModalOpen"
    @update:model-value="isAddChildDefaultScheduleModalClose"
  >
    <v-card v-if="bulkAddingSchedule">
      <v-card-text class="py-4 scrollable-content">
        <h2>登園パターン設定</h2>
        <v-row class="ml-4 mb-6">
          <div class="mb-4">
            <h4>登園時間</h4>
            <hour-minute-input class="mb-4" v-model="bulkDefaultMin.startMin"></hour-minute-input>
            <h4>降園時間</h4>
            <hour-minute-input v-model="bulkDefaultMin.endMin"></hour-minute-input>
          </div>
        </v-row>
        <v-progress-linear
          indeterminate
          color="primary"
          class="my-4"
          v-if="isFetching"
        ></v-progress-linear>

        <template v-else>
          <div class="default-schedule-header">
            <div class="default-schedule-header-item d-flex">
              <div class="col-name d-flex align-center justify-center font-weight-bold">
                {{ header.names }}
              </div>
              <div
                v-for="key in Object.keys(header.dayOfWeek)"
                :key="key"
                class="col-day d-flex flex-column align-center justify-center font-weight-bold"
              >
                {{ header.dayOfWeek[key] }}
                <v-checkbox
                  class="default-schedule-header-checkbox mt-1"
                  :model-value="defaultScheduleSelected[key]"
                  @update:model-value="val => { defaultScheduleSelected[key] = val === true; toggeleAll(key); }"
                  hide-details
                  density="compact"
                  color="primary"
                ></v-checkbox>
              </div>
            </div>
          </div>

          <div class="default-schedule">
            <div class="default-schedule-field d-flex">
              <div class="col-name">
                <div
                  class="default-schedule-body d-flex flex-column align-center justify-center"
                  v-for="(schedule, i) in scheduleTableRows"
                  :key="i"
                >
                  <div class="py-2">
                    {{ schedule.name }}
                  </div>
                  <div style="height: 24px;"></div>
                  <div style="width: 100%; border-top: solid 1px grey;"></div>
                </div>
              </div>
              
              <div>
                <div
                  class="default-schedule-body-items d-flex"
                  v-for="items in defaultScheduleItems"
                  :key="items.childId"
                >
                  <div
                    class="col-day default-schedule-item d-flex flex-column justify-center align-center"
                    v-for="(dayValue, dayKey) in items.days"
                    :key="`${items.childId}-${dayKey}`"
                  >
                    <v-checkbox 
                      :model-value="items.days[dayKey]"
                      @update:model-value="items.days[dayKey] = $event === true"
                      hide-details
                      density="compact"
                      color="primary"
                    ></v-checkbox>
                    <label v-if="items.defaultMin[dayKey].startMin && items.defaultMin[dayKey].endMin">
                      {{
                      `${String(Math.trunc(items.defaultMin[dayKey].startMin / 60)).padStart(2, '0')}:${String(items.defaultMin[dayKey].startMin % 60).padStart(2, '0')}
                      - ${String(Math.trunc(items.defaultMin[dayKey].endMin / 60)).padStart(2, '0')}:${String(items.defaultMin[dayKey].endMin % 60).padStart(2, '0')}`
                      }}
                    </label>
                    <label v-else>
                      -
                    </label>
                    <div style="width: 100%; border-top: solid 1px grey;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <v-row class="mb-4 mt-4">
          <v-col class="default-schedule-btn-delete text-center">
            <v-btn
              variant="flat"
              color="red"
              style="color: white"
              @click="deleteChildDefaultSchedule"
              :disabled="isUpdatingSchedule || isFetching"
              :loading="isUpdatingSchedule || isFetching"
            >登録情報の削除</v-btn>
          </v-col>
          <v-col class="default-schedule-btn-save text-center">
            <v-btn
              variant="flat"
              color="primary"
              style="color: white"
              @click="saveChildDefaultSchedule"
              :disabled="isUpdatingSchedule || isFetching"
              :loading="isUpdatingSchedule || isFetching"
            >保存</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- 一括登録モーダル -->
  <v-dialog
    max-width="1080px"
    v-model="isBulkAddScheduleModalOpen"
  >
    <v-card v-if="bulkAddingSchedule && bulkAddingUser">
      <v-card-text class="py-4">
        <v-row>
          <v-col>
            <div class="mb-4">
              <h4>園児氏名</h4>
              <h3> {{ bulkAddingUser.lastName }} {{ bulkAddingUser.firstName }} </h3>
            </div>
            <div class="mb-4">
              <h4>出欠</h4>
              <v-select
                variant="outlined"
                :items="absenseOptions"
                item-title="title"
                item-value="value"
                v-model="bulkAddingSchedule.status"
                color="primary"
              ></v-select>
            </div>
            <div class="mb-4" v-if="bulkAddingSchedule.status === 'attending'">
              <h4>登園時間</h4>
              <hour-minute-input class="mb-4" v-model="bulkAddingSchedule.startMin"></hour-minute-input>
              <h4>降園時間</h4>
              <hour-minute-input v-model="bulkAddingSchedule.endMin"></hour-minute-input>
            </div>
            <div class="mb-4" v-if="bulkAddingSchedule.status === 'isAbsent'">
              <h4>お休みの理由</h4>
              <v-select
                variant="outlined"
                :items="absenseReasons"
                item-title="title"
                item-value="value"
                v-model="bulkAddingSchedule.statusReason"
                color="primary"
              ></v-select>
              <div v-if="bulkAddingSchedule.statusReason === 'others'">
              <v-textarea
                label="コメント (必須)"
                v-model="bulkAddingSchedule.statusComment"
                color="primary"
              ></v-textarea>
            </div>
            </div>
          </v-col>
          <v-col>
            <month-date-picker
              v-model="bulkAddingSchedule.dates"
              :year-month="yearMonth"
            >
              <template #date="{date}">
                <!-- <div 
                  :class="[
                    'month-date-picker-cell'
                  ]"
                  :style="`background-color: ${getRegisteredSchedule(date) ? getRegisteredSchedule(date).color : null}`"
                > -->
                <div 
                  :class="[
                    'month-date-picker-cell'
                  ]"
                  :style="`background-color: ${getRegisteredSchedule(date) ? getRegisteredSchedule(date)?.color : null}`"
                >
                  <span v-if="getRegisteredSchedule(date)">
                    {{ getRegisteredSchedule(date)?.abbreviation}} 
                  </span>
                </div>
              </template>
            </month-date-picker>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions
        class="justify-center"
      >
        <v-btn
          variant="flat"
          color="primary"
          class="mx-2"
          @click="addBulkSchedule"
        >
          保存
        </v-btn>
      </v-card-actions>
      <v-progress-linear
        indeterminate
        color="primary"
        v-if="isUpdatingSchedule"
      ></v-progress-linear>
    </v-card>
  </v-dialog>


  <!-- スケジュール追加, 日付指定・ユーザー指定 -->
  <v-dialog
    max-width="1080px"
    v-model="isAddScheduleModalOpen"
  >
    <v-card v-if="addingUser && addingDate && addingSchedule">
      <v-card-title>登園パターン追加</v-card-title>
      <v-card-text>
        <v-row class="mb-4">
          <v-col>
            <div class="mb-4">
              <h4>園児氏名</h4>
              <h3> {{ addingUser.lastName }} {{ addingUser.firstName }} </h3>
            </div>
          </v-col>
          <v-col>
            <div class="mb-4">
              <h4>日付</h4>
              <h3> {{ addingDate }}</h3>
            </div>
          </v-col>
        </v-row>

        <v-row class="mb-4">
          <v-col>
            <div class="mb-4">
              <h4>出欠</h4>
              <v-select
                variant="outlined"
                :items="absenseOptions"
                v-model="addingSchedule.status"
                color="primary"
              ></v-select>
            </div>
          </v-col>
          <v-col>
          </v-col>
        </v-row>
        <div class="mb-4" v-if="addingSchedule.status === 'isAbsent'">
          <h4>お休みの理由</h4>
          <v-select
            variant="outlined"
            :items="absenseReasons"
            v-model="addingSchedule.statusReason"
            color="primary"
          ></v-select>
          <div class="my-2" v-if="addingSchedule.statusReason === 'others'">
            <v-textarea
              label="コメント (必須)"
              v-model="addingSchedule.statusComment"
              color="primary"
            ></v-textarea>
          </div>
        </div>
        <v-row class="mb-4" v-if="addingSchedule.status === 'attending'">
          <v-col>
            <div>登園時間</div>
            <hour-minute-input
              v-model="addingSchedule.startMin"
            />
          </v-col>
          <v-col>
            <div>降園時間</div>
            <hour-minute-input
              v-model="addingSchedule.endMin"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions
        class="justify-center"
      >
        <v-btn
          variant="flat"
          color="primary"
          class="mx-2"
          @click="addSchedule"
        >
          保存
        </v-btn>
      </v-card-actions>
      <v-progress-linear
        indeterminate
        color="primary"
        v-if="isUpdatingSchedule"
      ></v-progress-linear>
    </v-card>
  </v-dialog>

  <!-- スケジュール追加, 日付指定・ユーザー指定 -->
  <v-dialog
    max-width="1080px"
    v-model="isEditScheduleModalOpen"
  >
    <v-card v-if="editingSchedule && editingUser">
      <v-card-title>登園パターン追加</v-card-title>
      <v-card-text>
        <v-row class="mb-4">
          <v-col>
            <div class="mb-4">
              <h4>園児氏名</h4>
              <h3> {{ editingUser.lastName }} {{ editingUser.firstName }} </h3>
            </div>
          </v-col>
          <v-col>
            <div class="mb-4">
              <h4>日付</h4>
              <h3> {{ editingSchedule.date }}</h3>
            </div>
          </v-col>
        </v-row>

        <v-row class="mb-4">
          <v-col>
            <div class="mb-4">
              <h4>出欠</h4>
              <v-select
                variant="outlined"
                :items="absenseOptions"
                v-model="editingSchedule.status"
                color="primary"
              ></v-select>
            </div>
          </v-col>
          <v-col>
          </v-col>
        </v-row>
        <div class="mb-4" v-if="editingSchedule.status === 'isAbsent'">
          <h4>お休みの理由</h4>
          <v-select
            variant="outlined"
            :items="absenseReasons"
            v-model="editingSchedule.statusReason"
            color="primary"
          ></v-select>
          <div class="my-2" v-if="editingSchedule.statusReason === 'others'">
            <v-textarea
              label="コメント (必須)"
              v-model="editingSchedule.statusComment"
              color="primary"
            ></v-textarea>
          </div>
        </div>
        <v-row class="mb-4" v-if="editingSchedule.status === 'attending'">
          <v-col>
            <div>登園時間</div>
            <hour-minute-input
              v-model="editingSchedule.startMin"
            />
          </v-col>
          <v-col>
            <div>降園時間</div>
            <hour-minute-input
              v-model="editingSchedule.endMin"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions
        class="justify-center"
      >
        <v-btn
            variant="flat"
            color="red"
            dark
            class="mx-4"
            @click="deleteEditingShcedule"
        >
          削除
        </v-btn>
        <v-btn
          variant="flat"
          color="primary"
          class="mx-4"
          @click="saveEditingShcedule"
        >
          保存
        </v-btn>
      </v-card-actions>
      <v-progress-linear
        indeterminate
        color="primary"
        v-if="isUpdatingSchedule"
      ></v-progress-linear>
    </v-card>
  </v-dialog>
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import MonthPager from '@/components/atoms/MonthPager.vue';
import MonthDatePicker from '@/components/organisms/work-schedule/MonthDatePicker.vue'
import ScrollablePanels2 from '@/components/molecules/ScrollablePanels2.vue'
import HourMinuteInput from '@/components/molecules/HourMinuteInput.vue'
import dayjs from 'dayjs';
import { AttendanceScheduleMonthlySchema, AttendanceScheduleChildPartSchema, AttendanceScheduleDailyPartSchema, ChildDefaultSchedulePartSchema } from 'chaild-api/lib';
import { attendanceScheduleModule } from '@/store/viewModules/work-schedule/attendanceScheduleModule'

interface DataType {
  isFetching: boolean;
  isUpdatingSchedule: boolean;

  selectedClassId: number | string | null;

  addingUser: AttendanceScheduleChildPartSchema | null;
  addingDate: string | null;
  addingSchedule: UpdateChildAttendanceScheduleRequestParams | null;

  editingSchedule: AttendanceScheduleDailyPartSchema | null;
  editingUser: AttendanceScheduleChildPartSchema | null;

  bulkAddingUser: AttendanceScheduleChildPartSchema | null;
  bulkAddingSchedule: UpdateBulkAttendanceScheduleRequestParams | null;

  addingDefaultUser: AttendanceScheduleChildPartSchema | null;
  addChildDefaultSchedule: UpdateChildDefaultScheduleRequestParams | null;

  //園児基本スケジュール登録用
  header: Headers;
  defaultScheduleSelected: DefaultScheduleSelectItem;

  defaultScheduleItems: DefaultScheduleCheckdItem[];
  bulkDefaultMin: UpdateBulkDefaultRequestParams;
}

interface ScheduleTableRowItem {
  name: string;
  attendanceCount: number;
  offCount: number;
  schedules: AttendanceScheduleDailyPartSchema[];
  child: AttendanceScheduleChildPartSchema;
}

interface UpdateChildAttendanceScheduleRequestParams {
  date: string | number;
  childId: string | number;
  abbreviation?: string;
  color?: string;
  status?: 'attending' | 'isAbsent';
  statusReason?: string;
  statusComment?: string;
  startMin?: number;
  endMin?: number;
}

interface UpdateBulkAttendanceScheduleRequestParams {
  childId: string | number;
  abbreviation?: string;
  color?: string;
  status?: 'attending' | 'isAbsent';
  statusReason?: string;
  statusComment?: string;
  startMin?: number;
  endMin?: number;
  dates: number[];
}

//登園・降園のデフォルト設定ダイヤログのヘッダー
interface Headers { 
  names: string;
  dayOfWeek: {
  monday: string;
  tueday: string;
  wedday: string;
  thuday: string;
  friday: string;
  satday: string;
  };
}

//登園・降園のデフォルト設定ダイヤログのヘッダーチェックボックス
interface DefaultScheduleSelectItem {
  monday: boolean;
  tueday: boolean;
  wedday: boolean;
  thuday: boolean;
  friday: boolean;
  satday: boolean;
}

//登園・降園のデフォルト設定のチェックボックス用
type DefaultScheduleCheckdItem = {
  childId: number;
  days: {
    monday: boolean;
    tueday: boolean;
    wedday: boolean;
    thuday: boolean;
    friday: boolean;
    satday: boolean;
  };
  defaultMin: DefaultDayMin;
}

type DefaultDayMin = {
  monday: {
    startMin: number;
    endMin:   number;
  };
  tueday: {
    startMin: number;
    endMin:   number;
  };
  wedday: {
    startMin: number;
    endMin:   number;
  };
  thuday: {
    startMin: number;
    endMin:   number;
  };
  friday: {
    startMin: number;
    endMin:   number;
  };
  satday: {
    startMin: number;
    endMin:   number;
  };
}

//登園時間・降園時間
interface UpdateChildDefaultScheduleRequestParams {
  childId: number;
  Mins: ChildDefaultSchedulePartSchema;
}

interface UpdateBulkDefaultRequestParams {
  startMin: number;
  endMin: number;
}

const AbsenseReasons = [
  {
    title: '発熱',
    value: 'fever'
  },
  {
    title: '家庭の事情',
    value: 'personal'
  },
  {
    title: '溶連菌感染症',
    value: 'infStrep'
  },
  {
    title: 'マイコプラズマ肺炎',
    value: 'infMycoplasma'
  },
  {
    title: '手足口病',
    value: 'infHFMD'
  },
  {
    title: '伝染性紅斑（りんご病）',
    value: 'infSlappedCheek'
  },
  {
    title: 'ウイルス性胃腸炎（ノロ、ロタ、アデノ等）',
    value: 'infStomach'
  },
  {
    title: 'ヘルパンギーナ',
    value: 'infHerpangina'
  },
  {
    title: 'RSウィルス感染症',
    value: 'infRS'
  },
  {
    title: '帯状疱疹',
    value: 'infZoster'
  },
  {
    title: '突発性発しん',
    value: 'infRoseola'
  },
  {
    title: '伝染性膿痂疹（とびひ）',
    value: 'infImpetigo'
  },
  {
    title: '新型コロナウイルス',
    value: 'covid19'
  },
  {
    title: 'その他',
    value: 'others'
  },
]

export default defineComponent({
  components: {
    MonthPager,
    ScrollablePanels2,
    HourMinuteInput,
    MonthDatePicker,
},
  data: (): DataType => {
    return {
      isFetching: false,
      isUpdatingSchedule: false,

      selectedClassId: null,

      addingUser: null,
      addingDate: null,
      addingSchedule: null,

      editingSchedule: null,
      editingUser: null,

      bulkAddingUser: null,
      bulkAddingSchedule: null,

      addingDefaultUser: null,
      addChildDefaultSchedule: null,

      //登園・降園のデフォルト設定ダイヤログのヘッダー
      header: {
        names: '園児名',
        dayOfWeek: {
          monday: '月曜日',
          tueday: '火曜日',
          wedday: '水曜日',
          thuday: '木曜日',
          friday: '金曜日',
          satday: '土曜日'
        },
      },
      //登園・降園のデフォルト設定のチェックボックス用
      defaultScheduleSelected: {
        monday: false,
        tueday: false,
        wedday: false,
        thuday: false,
        friday: false,
        satday: false,
      },
      // 初期値として空の配列を設定
      defaultScheduleItems: [],
      bulkDefaultMin: {
        startMin: 0,
        endMin: 0
      }
    };
  },
  computed: {
    yearMonth: {
      get(): string {
        return attendanceScheduleModule.yearMonth
      },
      set(value: string) {
        this.onYearMonthChange(value)
      }
    },
    classes() {
      return attendanceScheduleModule.classes
    },
    attendanceSchedules() {
      return attendanceScheduleModule.attendanceSchedules
    },
    scheduleTableRows(): ScheduleTableRowItem[] {
      return this.attendanceSchedules.filter((schedule: AttendanceScheduleMonthlySchema) => {
        if (!this.selectedClassId) {
          return true
        }
        const findClass = schedule.child.nurseryClasses.find((nc) => nc.classId === this.selectedClassId)
        if (findClass) {
          return true
        }
        return false
      }).map((schedule: AttendanceScheduleMonthlySchema) => {
        let name = `${schedule.child.lastName} ${schedule.child.firstName}`
        if (name.length > 10) {
          name = name.slice(0, 10) + '...'
        }

        const formattedSchedules = schedule.dailySchedules.map((dailySchedule) => {
            if (dailySchedule.startMin == null) {
                // startMinがnullまたはundefinedの場合のデフォルト値を設定
                return {
                    ...dailySchedule,
                    startMinFormatted: '0:00',
                };
            }
            if (dailySchedule.endMin == null) {
                // startMinがnullまたはundefinedの場合のデフォルト値を設定
                return {
                    ...dailySchedule,
                    endMinFormatted: '0:00',
                };
            }
            const startHours = Math.floor(dailySchedule.startMin / 60); // 時
            const startMinutes = dailySchedule.startMin % 60; // 分
            const startFormattedTime = `${startHours}:${startMinutes.toString().padStart(2, '0')}`;
            const endHours = Math.floor(dailySchedule.endMin / 60); // 時
            const endMinutes = dailySchedule.endMin % 60; // 分
            const endFormattedTime = `${endHours}:${endMinutes.toString().padStart(2, '0')}`;


            return {
                ...dailySchedule,
                startMinFormatted: startFormattedTime,
                endMinFormatted: endFormattedTime,
                status: dailySchedule.status
            };
        });

        return {
          name,
          attendanceCount: 0,
          offCount: 0,
          schedules: formattedSchedules,
          child: schedule.child
        }
      })
    },
    numberOfDates(): number {
      const daysInMonth = dayjs(this.yearMonth).daysInMonth()
      return daysInMonth
    },
    tableDates(): Array<string> {
      const daysInMonth = dayjs(this.yearMonth).daysInMonth()
      const startOfMonth = dayjs(this.yearMonth).startOf('month')
      const dates = [...Array(daysInMonth)].map((emp, i) => {
        const date = dayjs(startOfMonth).add(i, 'day').locale('ja').format('M/D (ddd)')
        return date
      })

      return dates
    },
    isAddScheduleModalOpen: {
      get() {
        if (this.addingUser && this.addingDate) {
          return true
        }
        return false
      },
      set(value: boolean) {
        if (!value) {
          this.addingUser = null
          this.addingDate = null
          this.addingSchedule = null
        }
      }
    },
    //登園・降園のデフォルト設定ダイヤログ表示
    isAddChildDefaultScheduleModalOpen: {
      get() {
        if (this.addingDefaultUser) {
            // 各園児のチェックボックスを初期化して描画
            this.initializeChildCheckbox()
          return true
        }
        return false
      },
      set(value: boolean) {
        if (!value) {
          this.addingDefaultUser = null
        }
      }
    },
    isBulkAddScheduleModalOpen: {
      get() {
        if (this.bulkAddingUser) {
          return true
        }
        return false
      },
      set(value: boolean) {
        if (!value) {
          this.bulkAddingUser = null
          this.bulkAddingSchedule = null
        }
      }
    },
    isEditScheduleModalOpen: {
      get() {
        if (this.editingSchedule && this. editingUser) {
          return true
        }
        return false
      },
      set(value: boolean) {
        if (!value) {
          this.editingSchedule = null
          this.editingUser = null
        }
      }
    },
    absenseReasons() {
      return AbsenseReasons
    },
    absenseOptions() {
      return [
        {
          title: '出席',
          value: 'attending'
        },
        {
          title: '欠席',
          value: 'isAbsent'
        },
      ]
    },
  },
  methods: {
    async onYearMonthChange(value: string) {
      this.isFetching = true
      await attendanceScheduleModule.onYearMonthChange(value)
      this.isFetching = false
    },
    openAddScheduleModal(child: AttendanceScheduleChildPartSchema, date: string) {
      this.addingUser = child
      this.addingDate = date
      this.addingSchedule = {
        childId: child.childId,
        date: date,
      }

      if (child.defaultStartMin) {
        this.addingSchedule.startMin = child.defaultStartMin
      }

      if (child.defaultEndMin) {
        this.addingSchedule.endMin = child.defaultEndMin
      }
    },
    openEditScheduleModal(child: AttendanceScheduleChildPartSchema, schedule: AttendanceScheduleDailyPartSchema) {
      this.editingUser = child
      this.editingSchedule = schedule
    },
    openBulkAddScheduleModal(child: AttendanceScheduleChildPartSchema) {
      this.bulkAddingUser = child

      this.bulkAddingSchedule = {
        childId: child.childId,
        dates: [],
      }

      if (child.defaultStartMin) {
        this.bulkAddingSchedule.startMin = child.defaultStartMin
      }

      if (child.defaultEndMin) {
        this.bulkAddingSchedule.endMin = child.defaultEndMin
      }
    },
    // ダイアログが開かれたときに、defaultScheduleItems を初期化
    async initializeChildCheckbox() {
      this.isFetching = true
      this.defaultScheduleItems = await Promise.all(this.scheduleTableRows.map(async schedule => {
        const scheduleMins = await attendanceScheduleModule.getChildDefaultSchedule(schedule.child.childId);
         return {
          childId: schedule.child.childId,
          days: {
            monday: false,
            tueday: false,
            wedday: false,
            thuday: false,
            friday: false,
            satday: false
          },
          defaultMin: {
              monday: {
                startMin: scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.monStartMin : 0,
                endMin:   scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.monEndMin : 0
              },
              tueday: {
                startMin: scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.tueStartMin : 0,
                endMin:   scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.tueEndMin : 0
              },
              wedday: {
                startMin: scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.wedStartMin : 0,
                endMin:   scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.wedEndMin : 0
              },
              thuday: {
                startMin: scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.thuStartMin : 0,
                endMin:   scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.thuEndMin : 0
              },
              friday: {
                startMin: scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.friStartMin : 0,
                endMin:   scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.friEndMin : 0
              },
              satday: {
                startMin: scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.satStartMin : 0,
                endMin:   scheduleMins?.childId == schedule.child.childId ? scheduleMins?.Mins.satEndMin : 0
              },
            }
         };
      }));
      this.isFetching = false
    },
    // ダイアログが閉じられたときに呼ばれるメソッド
    isAddChildDefaultScheduleModalClose() {
      // ヘッダのチェックボックスを全てオフにする
      Object.keys(this.defaultScheduleSelected).forEach(day => {
        this.defaultScheduleSelected[day] = false;
      });

      // 各園児のチェックボックスを全てオフにする
      this.defaultScheduleItems.forEach(items => {
        Object.keys(items.days).forEach(day => {
          items.days[day] = false;
        });
      });
    },
    //登園・降園のデフォルト設定
    openAddChildDefaultScheduleModal(child: AttendanceScheduleChildPartSchema) {
      this.isUpdatingSchedule = true
      this.isFetching = true
      this.addingDefaultUser = child,
      this.bulkAddingSchedule = {
        childId: child.childId,
        dates: [],
      }
      if (child.defaultStartMin) {
        this.bulkAddingSchedule.startMin = child.defaultStartMin
      }
      if (child.defaultEndMin) {
        this.bulkAddingSchedule.endMin = child.defaultEndMin
      }
      this.isUpdatingSchedule = false
      this.isFetching = false
    },
    async addSchedule() {
      if (this.addingSchedule) {
        if (
          this.isAddScheduleModalOpen
          && this.addingSchedule
          && this.addingSchedule.status == 'attending'
          && this.addingSchedule.startMin
          && this.addingSchedule.endMin
          && this.addingSchedule.startMin >= this.addingSchedule.endMin
        ) {
          return alert('登降園の時刻が前後または一致している場合は登録できません。');
        } else if (
          this.isAddScheduleModalOpen
          && this.addingSchedule
          && this.addingSchedule.status == 'attending'
          && this.addingSchedule.startMin
          && !this.addingSchedule.endMin
        ) {
          return alert('登降園の時刻が前後または一致している場合は登録できません。');
        } else if (
          this.isAddScheduleModalOpen
          && this.addingSchedule
          && this.addingSchedule.status == 'attending'
          && !this.addingSchedule.startMin
          && !this.addingSchedule.endMin
        ) {
          return alert('登降園の時刻が前後または一致している場合は登録できません。');
        } else if (
          this.isAddScheduleModalOpen
          && this.addingSchedule.status == 'isAbsent'
        ) {
          this.addingSchedule.startMin = undefined;
          this.addingSchedule.endMin = undefined;
        }
        this.isUpdatingSchedule = true
        await attendanceScheduleModule.updateChildAttendanceSchedule(this.addingSchedule)
        this.isUpdatingSchedule = false
        this.isAddScheduleModalOpen = false
      }
    },
    async addDefaultSchedules() {
      this.isUpdatingSchedule = true
      this.isFetching = true
      await attendanceScheduleModule.addDefaultAttendanceSchedules();
      this.isUpdatingSchedule = false
      this.isFetching = false
    },
    async addBulkSchedule() {
      if (this.bulkAddingSchedule) {
        if (
          this.isBulkAddScheduleModalOpen
          && this.bulkAddingSchedule
          && this.bulkAddingSchedule.status == 'attending'
          && this.bulkAddingSchedule.startMin
          && this.bulkAddingSchedule.endMin
          && this.bulkAddingSchedule.startMin >= this.bulkAddingSchedule.endMin
        ) {
          return alert('登降園の時刻が前後または一致している場合は登録できません。');
        } else if (
          this.isBulkAddScheduleModalOpen
          && this.bulkAddingSchedule
          && this.bulkAddingSchedule.status == 'attending'
          && this.bulkAddingSchedule.startMin
          && !this.bulkAddingSchedule.endMin
        ) {
          return alert('登降園の時刻が前後または一致している場合は登録できません。');
        } else if (
          this.isBulkAddScheduleModalOpen
          && this.bulkAddingSchedule
          && this.bulkAddingSchedule.status == 'attending'
          && !this.bulkAddingSchedule.startMin
          && !this.bulkAddingSchedule.endMin
        ) {
          return alert('登降園の時刻が前後または一致している場合は登録できません。');
        }

        this.isUpdatingSchedule = true
        const schedule = { ...this.bulkAddingSchedule } as UpdateBulkAttendanceScheduleRequestParams

        await attendanceScheduleModule.updateChildAttendanceMonthlySchedule({
          childId: this.bulkAddingSchedule.childId,
          dailySchedules: schedule.dates.map((date) => {
            const d = dayjs(this.yearMonth).date(date).format('YYYY-MM-DD')
            
            const startMin = schedule.status == 'isAbsent' ? null : schedule.startMin;
            const endMin = schedule.status == 'isAbsent' ? null : schedule.endMin;
            return {
              date: d,
              abbreviation: null,
              color: null,
              status: schedule.status,
              statusReason: schedule.statusReason,
              statusComment: schedule.statusComment,
              startMin: startMin,
              endMin: endMin
            } as AttendanceScheduleDailyPartSchema
          })
        })
        this.isUpdatingSchedule = false
        this.isBulkAddScheduleModalOpen = false
      }
    },
    async saveEditingShcedule() {
      if (this.editingSchedule && this.editingUser) {
        if (
          this.isEditScheduleModalOpen
          && this.editingSchedule
          && this.editingSchedule.status == 'attending'
          && this.editingSchedule.startMin
          && this.editingSchedule.endMin
          && this.editingSchedule.startMin >= this.editingSchedule.endMin
        ) {
          return alert('登降園の時刻が前後または一致している場合は登録できません。');
        } else if (
          this.isEditScheduleModalOpen
          && this.editingSchedule
          && this.editingSchedule.status == 'attending'
          && this.editingSchedule.startMin
          && !this.editingSchedule.endMin
        ) {
          return alert('登降園の時刻が前後または一致している場合は登録できません。');
        } else if (
          this.isEditScheduleModalOpen
          && this.editingSchedule
          && this.editingSchedule.status == 'attending'
          && !this.editingSchedule.startMin
          && !this.editingSchedule.endMin
        ) {
          return alert('登降園の時刻が前後または一致している場合は登録できません。');
        }
        this.isUpdatingSchedule = true
        const startMin = this.editingSchedule.status == 'isAbsent' ? undefined : this.editingSchedule.startMin;
        const endMin = this.editingSchedule.status == 'isAbsent' ? undefined : this.editingSchedule.endMin;
        await attendanceScheduleModule.updateChildAttendanceSchedule({
          date: this.editingSchedule.date,
          childId: this.editingUser.childId,
          abbreviation: this.editingSchedule.abbreviation || undefined,
          color: this.editingSchedule.color || undefined,
          status: this.editingSchedule.status || undefined,
          statusReason: this.editingSchedule.statusReason || undefined,
          startMin: startMin || undefined,
          statusComment: this.editingSchedule.statusComment || undefined,
          endMin: endMin || undefined
        })
        this.isUpdatingSchedule = false
        this.isEditScheduleModalOpen = false
      }
    },
    async deleteEditingShcedule() {
      if (this.editingSchedule && this.editingUser) {
        this.isUpdatingSchedule = true
        await attendanceScheduleModule.deleteChildAttendanceSchedule({
          date: this.editingSchedule.date,
          childId: this.editingUser.childId,
          abbreviation: this.editingSchedule.abbreviation || undefined,
          color: this.editingSchedule.color || undefined,
          status: this.editingSchedule.status || undefined,
          statusReason: this.editingSchedule.statusReason || undefined,
          startMin: this.editingSchedule.startMin || undefined,
          statusComment: this.editingSchedule.statusComment || undefined,
          endMin: this.editingSchedule.endMin || undefined
        })
        this.isUpdatingSchedule = false
        this.isEditScheduleModalOpen = false
      }
    },
    //登園・降園のデフォルト設定の登録
    async saveChildDefaultSchedule(){
      this.isUpdatingSchedule = true
      this.isFetching = true
      let checkCnt = 0

      if (
        this.bulkDefaultMin.startMin > this.bulkDefaultMin.endMin
        ||  this.bulkDefaultMin.startMin == this.bulkDefaultMin.endMin
      ) {
        this.isUpdatingSchedule = false
        this.isFetching = false
        return alert('登降園の時刻が前後または一致している場合は登録できません。');
      }
      // 各園児のデータを処理して新しい配列を作成する
      this.defaultScheduleItems.forEach((item) => {
        this.addChildDefaultSchedule = {
          childId: item.childId,
          Mins: {
            monStartMin: item.defaultMin.monday.startMin,
            monEndMin:   item.defaultMin.monday.endMin,
            tueStartMin: item.defaultMin.tueday.startMin,
            tueEndMin:   item.defaultMin.tueday.endMin,
            wedStartMin: item.defaultMin.wedday.startMin,
            wedEndMin:   item.defaultMin.wedday.endMin,
            thuStartMin: item.defaultMin.thuday.startMin,
            thuEndMin:   item.defaultMin.thuday.endMin,
            friStartMin: item.defaultMin.friday.startMin,
            friEndMin:   item.defaultMin.friday.endMin,
            satStartMin: item.defaultMin.satday.startMin,
            satEndMin:   item.defaultMin.satday.endMin,
          },
        };

        if (item.days.monday) {
              this.addChildDefaultSchedule.Mins.monStartMin = this.bulkDefaultMin.startMin;
              this.addChildDefaultSchedule.Mins.monEndMin   = this.bulkDefaultMin.endMin;
              item.defaultMin.monday.startMin = this.bulkDefaultMin.startMin;
              item.defaultMin.monday.endMin = this.bulkDefaultMin.endMin;
              checkCnt = 1;
          }
        if (item.days.tueday) {
            this.addChildDefaultSchedule.Mins.tueStartMin = this.bulkDefaultMin.startMin;
            this.addChildDefaultSchedule.Mins.tueEndMin   = this.bulkDefaultMin.endMin;
            item.defaultMin.tueday.startMin = this.bulkDefaultMin.startMin;
            item.defaultMin.tueday.endMin = this.bulkDefaultMin.endMin;
            checkCnt = 1;
        }
        if (item.days.wedday) {
            this.addChildDefaultSchedule.Mins.wedStartMin = this.bulkDefaultMin.startMin;
            this.addChildDefaultSchedule.Mins.wedEndMin   = this.bulkDefaultMin.endMin;
            item.defaultMin.wedday.startMin = this.bulkDefaultMin.startMin;
            item.defaultMin.wedday.endMin = this.bulkDefaultMin.endMin;
            checkCnt = 1;
        }
        if (item.days.thuday) {
            this.addChildDefaultSchedule.Mins.thuStartMin = this.bulkDefaultMin.startMin;
            this.addChildDefaultSchedule.Mins.thuEndMin   = this.bulkDefaultMin.endMin;
            item.defaultMin.thuday.startMin = this.bulkDefaultMin.startMin;
            item.defaultMin.thuday.endMin = this.bulkDefaultMin.endMin;
            checkCnt = 1;
        }
        if (item.days.friday) {
            this.addChildDefaultSchedule.Mins.friStartMin = this.bulkDefaultMin.startMin;
            this.addChildDefaultSchedule.Mins.friEndMin   = this.bulkDefaultMin.endMin;
            item.defaultMin.friday.startMin = this.bulkDefaultMin.startMin;
            item.defaultMin.friday.endMin = this.bulkDefaultMin.endMin;
            checkCnt = 1;
        }
        if (item.days.satday) {
            this.addChildDefaultSchedule.Mins.satStartMin = this.bulkDefaultMin.startMin;
            this.addChildDefaultSchedule.Mins.satEndMin   = this.bulkDefaultMin.endMin;
            item.defaultMin.satday.startMin = this.bulkDefaultMin.startMin;
            item.defaultMin.satday.endMin = this.bulkDefaultMin.endMin;
            checkCnt = 1;
        }

        attendanceScheduleModule.updateChildDefaultSchedule(this.addChildDefaultSchedule);
      });   

      if(checkCnt === 0){
        this.isUpdatingSchedule = false
        this.isFetching = false
        return alert('選択されていません');
      }

      Object.keys(this.defaultScheduleSelected).forEach(day => { 
        this.defaultScheduleSelected[day] = false;
      });

      // 各園児のチェックボックスを全てオフにする
      this.defaultScheduleItems.forEach(items => {
        Object.keys(items.days).forEach(day => {
          items.days[day] = false;
        });
      });
      
      this.isUpdatingSchedule = false
      this.isFetching = false
      return alert('保存しました');
    },
    //登園・降園のデフォルト設定の登録削除
    async deleteChildDefaultSchedule() {
      this.isUpdatingSchedule = true
      this.isFetching = true
      let checkCnt = 0
      // 各園児のデータを処理して新しい配列を作成する
      this.defaultScheduleItems.forEach((item) => {
        this.addChildDefaultSchedule = {
          childId: item.childId,
          Mins: {
            monStartMin: item.defaultMin.monday.startMin,
            monEndMin:   item.defaultMin.monday.endMin,
            tueStartMin: item.defaultMin.tueday.startMin,
            tueEndMin:   item.defaultMin.tueday.endMin,
            wedStartMin: item.defaultMin.wedday.startMin,
            wedEndMin:   item.defaultMin.wedday.endMin,
            thuStartMin: item.defaultMin.thuday.startMin,
            thuEndMin:   item.defaultMin.thuday.endMin,
            friStartMin: item.defaultMin.friday.startMin,
            friEndMin:   item.defaultMin.friday.endMin,
            satStartMin: item.defaultMin.satday.startMin,
            satEndMin:   item.defaultMin.satday.endMin,
          },
        };

        if (item.days.monday) {
            this.addChildDefaultSchedule.Mins.monStartMin = 0;
            this.addChildDefaultSchedule.Mins.monEndMin   = 0;
            item.defaultMin.monday.startMin = 0;
            item.defaultMin.monday.endMin = 0;
            checkCnt = 1;
          }
        if (item.days.tueday) {
            this.addChildDefaultSchedule.Mins.tueStartMin = 0;
            this.addChildDefaultSchedule.Mins.tueEndMin   = 0;
            item.defaultMin.tueday.startMin = 0;
            item.defaultMin.tueday.endMin = 0;
            checkCnt = 1;
        }
        if (item.days.wedday) {
            this.addChildDefaultSchedule.Mins.wedStartMin = 0;
            this.addChildDefaultSchedule.Mins.wedEndMin   = 0;
            item.defaultMin.wedday.startMin = 0;
            item.defaultMin.wedday.endMin = 0;
            checkCnt = 1;
        }
        if (item.days.thuday) {
            this.addChildDefaultSchedule.Mins.thuStartMin = 0;
            this.addChildDefaultSchedule.Mins.thuEndMin   = 0;
            item.defaultMin.thuday.startMin = 0;
            item.defaultMin.thuday.endMin = 0;
            checkCnt = 1;
        }
        if (item.days.friday) {
            this.addChildDefaultSchedule.Mins.friStartMin = 0;
            this.addChildDefaultSchedule.Mins.friEndMin   = 0;
            item.defaultMin.friday.startMin = 0;
            item.defaultMin.friday.endMin = 0;
            checkCnt = 1;
        }
        if (item.days.satday) {
            this.addChildDefaultSchedule.Mins.satStartMin = 0;
            this.addChildDefaultSchedule.Mins.satEndMin   = 0;
            item.defaultMin.satday.startMin = 0;
            item.defaultMin.satday.endMin = 0;
            checkCnt = 1;
        }

        attendanceScheduleModule.deleteChildDefaultSchedule(this.addChildDefaultSchedule);
      });

      if(checkCnt === 0){
        this.isUpdatingSchedule = false
        this.isFetching = false
        return alert('選択されていません');
      }

      Object.keys(this.defaultScheduleSelected).forEach(day => {
        this.defaultScheduleSelected[day] = false;
      });

      // 各園児のチェックボックスを全てオフにする
      this.defaultScheduleItems.forEach(items => {
        Object.keys(items.days).forEach(day => {
          items.days[day] = false;
        });
      });

      this.isUpdatingSchedule = false
      this.isFetching = false
      return alert('削除しました');
    },
    getRegisteredSchedule(date: number) {
      if (this.bulkAddingUser) {
        const findSchedules = this.attendanceSchedules.find((as) => as.child.childId === this.bulkAddingUser!.childId)
        if (findSchedules) {
          const targetDate = dayjs(`${this.yearMonth}-${date}`).format('YYYY-MM-DD')
          const dateSchedule = findSchedules.dailySchedules.find((ds) => ds.date === targetDate)
          console.log(`dateSchedule: ${JSON.stringify(dateSchedule)}`)
          if (dateSchedule) {
            return dateSchedule
          }
        }
      }
      return null
    },
    toggeleAll(DW: string) {
      // 全選択or全解除の判定
      const itemValue = this.defaultScheduleSelected[DW] ? true : false;

      // 各園児のチェックボックスに反映
      this.defaultScheduleItems.forEach((items) => {
        items.days[DW] = itemValue
      })
    }
  },
  async mounted() {
    this.isFetching = true
    await Promise.all([
      attendanceScheduleModule.listAttendanceSchedules(),
      attendanceScheduleModule.listClass(),
    ])
    this.isFetching = false
  }
})

</script>
<style lang="scss" scoped>
h2 {
  text-align: start;
  margin: 10px 0;
  padding-bottom: 20px;
}

.panel-header {
  display: flex;
}

.panel-left {
}

.panel-right {
}

.schedule-col {

  border-right: solid 1px #f0f0f0;
  &.name {
    width: 180px;
  }
  &.count {
    width: 50px;
  }

  &.date {
    width: 50px;
  }

  &.actions {
    width: 100px;
    padding-left: 4px;
    padding-right: 4px;
  }
}

.schedule-header-cell {
  padding: 8px;
  font-weight: bold;
  text-align: center;
  font-size: 12px;
  height: 50px;
}

.schedule-row {
  display: flex;
  height: 40px;
  border-bottom: solid 1px #f0f0f0;
  background-color: white;
}

.schedule-body-cell {
  font-size: 14px;
  text-align: center;
  padding: 8px 0;

  &.date.active {
    cursor: pointer;
    height: 100%;
    &:hover {
      transition-property: all;
      transition-duration: .2s;
      opacity: .6;
    }
  }

  &.date.add {
    cursor: pointer;
    height: 100%;
    &:hover {
      transition-property: all;
      transition-duration: .2s;
      background-color: #f0f0f0;
    }
  }
}

.month-date-picker-cell {
  height: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

//園児基本スケジュール登録用
.default-schedule {
  height: 400px;
  overflow-y: scroll;
}

.default-schedule::-webkit-scrollbar {
  display: none;
}

.default-schedule-btn-delete {
  text-align: center;
  align-content: center;
  width: 100%;
  padding: 5% 0 0 30%;
}

.default-schedule-btn-save {
  text-align: center;
  align-content: center;
  width: 100%;
  padding: 5% 30% 0 0;
}

.default-schedule-header {
  position: sticky;
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px;
  width: 100%;
}

.default-schedule-header-item {
  display: flex;
  align-items: center;
  text-align: center;
  font-weight: bold;
  //padding: 10px 4px 0 58px;
}

.default-schedule-header-items {
  //padding: 0 35px 0 65px;
  position: sticky;
  width: 100%;
}

.default-schedule-secret-item {
  padding-right: 22px;
}

.default-schedule-header-checkbox {
 //padding-left: 12px;
 text-align: center;
 align-items: center;
}

.default-schedule-field {
  display: flex;
  text-align: center;
  width: 1032px;
  margin: auto;
}

.default-schedule-name-body {
  display: block;
  width: 155px;
  font-weight: bold;
  font-size: 15px;
}

.default-schedule-body {
  white-space: nowrap;
  align-content: center;
  height: 50px;
}

.default-schedule-item {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 80px;
}

.default-schedule-body-items {
  display: flex;
}

.default-schedule-checkbox {
  position: relative;
  top: 3px;
  start: 56px;
}

.default-schedule-checkbox-label {
  margin: 55px 10px 0 0;
}

.scrollable-content {
  overflow-y: auto; /* 縦スクロールを有効化 */
}

.col-name {
  width: 150px;
  min-width: 150px;
  flex-shrink: 0;
}

.col-day {
  width: 150px;
  min-width: 150px;
  flex-shrink: 0;
  height: 100%;
}

/* 縦の高さも一致させるために追記 */
.default-schedule-body {
  height: 80px; /* 曜日のチェックボックス＋時間の2段構成に合わせる */
}
.default-schedule-item {
  height: 80px;
}

</style>
